import { useTranslation } from 'react-i18next';
/* eslint-disable react/jsx-pascal-case */
import React, { useState} from "react";
import { COURSE_CATEGORIES } from "../../../../LambdaFunctions/shared/courseCategories";
import OfferDataArray from "../../../data/OfferDataArray";
import OfferCard from "./OfferCard";

function OfferPageAccordion() {
  const { t } = useTranslation();

  const [selectedGroup, setSelectedGroup] = useState(OfferDataArray[0].id);
  const [isMenuShowing, setisMenuShowing] = useState(true);
  const [collapse, setCollapse] = useState(false);

  const selectedGroupInfo = OfferDataArray.find(
    (group) => group.id === selectedGroup,
  );

  const categoryColor = offerId => COURSE_CATEGORIES.find(category => category.offerId === offerId).color;

  const handleReturn = () => {
    setCollapse(false);
    setTimeout(() => {
      setisMenuShowing(true);
    }, 100);
  };


  const handleGroupSelect = (group) => {
    setSelectedGroup(group.id);
    setCollapse(true);
    setTimeout(() => {
      setisMenuShowing(false);
    }, 300);
  };

  return (
    <div className="">
      <div className="col-12 m-0 p-0" >
        <div className={`offer-accordion-menu m-0 p-0 ${collapse ? "offer-collapse" : "offer-expand"} `}>
          {isMenuShowing
            ? (
              <div className="offer-tabs-column col-12 m-0 p-0">
                {OfferDataArray.map((group) => (
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={event => { if (['Enter', ' '].includes(event.key)) { event.preventDefault(); handleGroupSelect(group); } }}
                    key={group.id}
                    className="m-0 p-3 pr-4 offer-tab"
                    style={{ backgroundColor: categoryColor(group.id) }}
                    onClick={() => handleGroupSelect(group)}
                  >
                    <p className={`offer-tab-title m-0 p-0 ${collapse ? "offer-collapse" : "offer-expand"} `}>{t(`public:courseDescriptions.${group.id}.name`)}</p>
                  </div>
                ))}
              </div>
            )
            : (
              <div
                className="offer-return-column"
                style={{ backgroundColor: categoryColor(selectedGroup) }}
                onClick={handleReturn}
                role="button"
                tabIndex={0}
                aria-label={t('common:back')}
                onKeyDown={event => { if (['Enter', ' '].includes(event.key)) { event.preventDefault(); handleReturn(); } }}
              >
                <i className="offer-return-icon fas fa-chevron-circle-right fa-lg" />
              </div>
            )}
        </div>


        {selectedGroupInfo && (
          <div className="offer-card m-0" style={{ backgroundColor: `${categoryColor(selectedGroup)}80` }}>
            <OfferCard
              id={selectedGroupInfo.id}
              name={t(`public:courseDescriptions.${selectedGroupInfo.id}.name`)}
              imgURL={selectedGroupInfo.imgURL}
              groupDescription={t(`public:courseDescriptions.${selectedGroupInfo.id}.groupDescription`)}
            />
          </div>
        )}
      </div>
    </div>
  );
}


export default OfferPageAccordion;
